

















import { Vue, Component, Prop, Model } from 'vue-property-decorator';

@Component({})
export default class BaseCheckbox extends Vue {
    @Model('change', { type: Boolean, default: false }) checked!: boolean;
    @Prop({ default: '' }) readonly value!: string;
    @Prop({ default: '' }) readonly name!: string;
    @Prop({ default: false }) readonly disabled!: boolean;

    get modelWrapper() {
        return this.checked;
    }

    set modelWrapper(value) {
        this.$emit('change', value);
    }
}
